export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	weedle: {
		inherit: true,
		unreleasedHidden: true,
	},
	beedrill: {
		inherit: true,
		unreleasedHidden: true,
	},
	ekans: {
		inherit: true,
		unreleasedHidden: true,
	},
	arbok: {
		inherit: true,
		unreleasedHidden: true,
	},
	paras: {
		inherit: true,
		unreleasedHidden: true,
	},
	parasect: {
		inherit: true,
		unreleasedHidden: true,
	},
	venonat: {
		inherit: true,
		unreleasedHidden: true,
	},
	venomoth: {
		inherit: true,
		unreleasedHidden: true,
	},
	grimer: {
		inherit: true,
		unreleasedHidden: true,
	},
	muk: {
		inherit: true,
		unreleasedHidden: true,
	},
	pinsir: {
		inherit: true,
		unreleasedHidden: true,
	},
	ditto: {
		inherit: true,
		unreleasedHidden: true,
	},
	snorlax: {
		inherit: true,
		unreleasedHidden: true,
	},
	aipom: {
		inherit: true,
		unreleasedHidden: true,
	},
	pineco: {
		inherit: true,
		unreleasedHidden: true,
	},
	forretress: {
		inherit: true,
		unreleasedHidden: true,
	},
	heracross: {
		inherit: true,
		unreleasedHidden: true,
	},
	lugia: {
		inherit: true,
		unreleasedHidden: true,
	},
	hooh: {
		inherit: true,
		unreleasedHidden: true,
	},
	wurmple: {
		inherit: true,
		unreleasedHidden: true,
	},
	beautifly: {
		inherit: true,
		unreleasedHidden: true,
	},
	dustox: {
		inherit: true,
		unreleasedHidden: true,
	},
	seedot: {
		inherit: true,
		unreleasedHidden: true,
	},
	nuzleaf: {
		inherit: true,
		unreleasedHidden: true,
	},
	shiftry: {
		inherit: true,
		unreleasedHidden: true,
	},
	shroomish: {
		inherit: true,
		unreleasedHidden: true,
	},
	breloom: {
		inherit: true,
		unreleasedHidden: true,
	},
	nincada: {
		inherit: true,
		unreleasedHidden: true,
	},
	ninjask: {
		inherit: true,
		unreleasedHidden: true,
	},
	roselia: {
		inherit: true,
		unreleasedHidden: true,
	},
	gulpin: {
		inherit: true,
		unreleasedHidden: true,
	},
	swalot: {
		inherit: true,
		unreleasedHidden: true,
	},
	zangoose: {
		inherit: true,
		unreleasedHidden: true,
	},
	seviper: {
		inherit: true,
		unreleasedHidden: true,
	},
	turtwig: {
		inherit: true,
		unreleasedHidden: true,
	},
	grotle: {
		inherit: true,
		unreleasedHidden: true,
	},
	torterra: {
		inherit: true,
		unreleasedHidden: true,
	},
	chimchar: {
		inherit: true,
		unreleasedHidden: true,
	},
	monferno: {
		inherit: true,
		unreleasedHidden: true,
	},
	infernape: {
		inherit: true,
		unreleasedHidden: true,
	},
	piplup: {
		inherit: true,
		unreleasedHidden: true,
	},
	prinplup: {
		inherit: true,
		unreleasedHidden: true,
	},
	empoleon: {
		inherit: true,
		unreleasedHidden: true,
	},
	kricketot: {
		inherit: true,
		unreleasedHidden: true,
	},
	kricketune: {
		inherit: true,
		unreleasedHidden: true,
	},
	budew: {
		inherit: true,
		unreleasedHidden: true,
	},
	roserade: {
		inherit: true,
		unreleasedHidden: true,
	},
	combee: {
		inherit: true,
		unreleasedHidden: true,
	},
	vespiquen: {
		inherit: true,
		unreleasedHidden: true,
	},
	ambipom: {
		inherit: true,
		unreleasedHidden: true,
	},
	dialga: {
		inherit: true,
		unreleasedHidden: true,
	},
	palkia: {
		inherit: true,
		unreleasedHidden: true,
	},
	giratina: {
		inherit: true,
		unreleasedHidden: true,
	},
	patrat: {
		inherit: true,
		unreleasedHidden: true,
	},
	watchog: {
		inherit: true,
		unreleasedHidden: true,
	},
	lillipup: {
		inherit: true,
		unreleasedHidden: true,
	},
	herdier: {
		inherit: true,
		unreleasedHidden: true,
	},
	stoutland: {
		inherit: true,
		unreleasedHidden: true,
	},
	purrloin: {
		inherit: true,
		unreleasedHidden: true,
	},
	liepard: {
		inherit: true,
		unreleasedHidden: true,
	},
	pansage: {
		inherit: true,
		unreleasedHidden: true,
	},
	simisage: {
		inherit: true,
		unreleasedHidden: true,
	},
	pansear: {
		inherit: true,
		unreleasedHidden: true,
	},
	simisear: {
		inherit: true,
		unreleasedHidden: true,
	},
	panpour: {
		inherit: true,
		unreleasedHidden: true,
	},
	simipour: {
		inherit: true,
		unreleasedHidden: true,
	},
	pidove: {
		inherit: true,
		unreleasedHidden: true,
	},
	tranquill: {
		inherit: true,
		unreleasedHidden: true,
	},
	unfezant: {
		inherit: true,
		unreleasedHidden: true,
	},
	blitzle: {
		inherit: true,
		unreleasedHidden: true,
	},
	zebstrika: {
		inherit: true,
		unreleasedHidden: true,
	},
	roggenrola: {
		inherit: true,
		unreleasedHidden: true,
	},
	boldore: {
		inherit: true,
		unreleasedHidden: true,
	},
	gigalith: {
		inherit: true,
		unreleasedHidden: true,
	},
	woobat: {
		inherit: true,
		unreleasedHidden: true,
	},
	swoobat: {
		inherit: true,
		unreleasedHidden: true,
	},
	drilbur: {
		inherit: true,
		unreleasedHidden: true,
	},
	excadrill: {
		inherit: true,
		unreleasedHidden: true,
	},
	audino: {
		inherit: true,
		unreleasedHidden: true,
	},
	timburr: {
		inherit: true,
		unreleasedHidden: true,
	},
	gurdurr: {
		inherit: true,
		unreleasedHidden: true,
	},
	conkeldurr: {
		inherit: true,
		unreleasedHidden: true,
	},
	tympole: {
		inherit: true,
		unreleasedHidden: true,
	},
	palpitoad: {
		inherit: true,
		unreleasedHidden: true,
	},
	seismitoad: {
		inherit: true,
		unreleasedHidden: true,
	},
	throh: {
		inherit: true,
		unreleasedHidden: true,
	},
	sawk: {
		inherit: true,
		unreleasedHidden: true,
	},
	sewaddle: {
		inherit: true,
		unreleasedHidden: true,
	},
	swadloon: {
		inherit: true,
		unreleasedHidden: true,
	},
	leavanny: {
		inherit: true,
		unreleasedHidden: true,
	},
	venipede: {
		inherit: true,
		unreleasedHidden: true,
	},
	whirlipede: {
		inherit: true,
		unreleasedHidden: true,
	},
	scolipede: {
		inherit: true,
		unreleasedHidden: true,
	},
	cottonee: {
		inherit: true,
		unreleasedHidden: true,
	},
	whimsicott: {
		inherit: true,
		unreleasedHidden: true,
	},
	petilil: {
		inherit: true,
		unreleasedHidden: true,
	},
	lilligant: {
		inherit: true,
		unreleasedHidden: true,
	},
	basculin: {
		inherit: true,
		unreleasedHidden: true,
	},
	basculinbluestriped: {
		inherit: true,
		unreleasedHidden: true,
	},
	sandile: {
		inherit: true,
		unreleasedHidden: true,
	},
	krokorok: {
		inherit: true,
		unreleasedHidden: true,
	},
	krookodile: {
		inherit: true,
		unreleasedHidden: true,
	},
	maractus: {
		inherit: true,
		unreleasedHidden: true,
	},
	dwebble: {
		inherit: true,
		unreleasedHidden: true,
	},
	crustle: {
		inherit: true,
		unreleasedHidden: true,
	},
	scraggy: {
		inherit: true,
		unreleasedHidden: true,
	},
	scrafty: {
		inherit: true,
		unreleasedHidden: true,
	},
	sigilyph: {
		inherit: true,
		unreleasedHidden: true,
	},
	tirtouga: {
		inherit: true,
		unreleasedHidden: true,
	},
	carracosta: {
		inherit: true,
		unreleasedHidden: true,
	},
	trubbish: {
		inherit: true,
		unreleasedHidden: true,
	},
	garbodor: {
		inherit: true,
		unreleasedHidden: true,
	},
	minccino: {
		inherit: true,
		unreleasedHidden: true,
	},
	cinccino: {
		inherit: true,
		unreleasedHidden: true,
	},
	gothorita: {
		inherit: true,
		unreleasedHidden: true,
	},
	gothitelle: {
		inherit: true,
		unreleasedHidden: true,
	},
	solosis: {
		inherit: true,
		unreleasedHidden: true,
	},
	duosion: {
		inherit: true,
		unreleasedHidden: true,
	},
	reuniclus: {
		inherit: true,
		unreleasedHidden: true,
	},
	ducklett: {
		inherit: true,
		unreleasedHidden: true,
	},
	swanna: {
		inherit: true,
		unreleasedHidden: true,
	},
	vanillite: {
		inherit: true,
		unreleasedHidden: true,
	},
	vanillish: {
		inherit: true,
		unreleasedHidden: true,
	},
	vanilluxe: {
		inherit: true,
		unreleasedHidden: true,
	},
	deerling: {
		inherit: true,
		unreleasedHidden: true,
	},
	sawsbuck: {
		inherit: true,
		unreleasedHidden: true,
	},
	emolga: {
		inherit: true,
		unreleasedHidden: true,
	},
	karrablast: {
		inherit: true,
		unreleasedHidden: true,
	},
	escavalier: {
		inherit: true,
		unreleasedHidden: true,
	},
	foongus: {
		inherit: true,
		unreleasedHidden: true,
	},
	amoonguss: {
		inherit: true,
		unreleasedHidden: true,
	},
	frillish: {
		inherit: true,
		unreleasedHidden: true,
	},
	jellicent: {
		inherit: true,
		unreleasedHidden: true,
	},
	alomomola: {
		inherit: true,
		unreleasedHidden: true,
	},
	joltik: {
		inherit: true,
		unreleasedHidden: true,
	},
	galvantula: {
		inherit: true,
		unreleasedHidden: true,
	},
	klang: {
		inherit: true,
		unreleasedHidden: true,
	},
	klinklang: {
		inherit: true,
		unreleasedHidden: true,
	},
	elgyem: {
		inherit: true,
		unreleasedHidden: true,
	},
	beheeyem: {
		inherit: true,
		unreleasedHidden: true,
	},
	axew: {
		inherit: true,
		unreleasedHidden: true,
	},
	fraxure: {
		inherit: true,
		unreleasedHidden: true,
	},
	haxorus: {
		inherit: true,
		unreleasedHidden: true,
	},
	cubchoo: {
		inherit: true,
		unreleasedHidden: true,
	},
	beartic: {
		inherit: true,
		unreleasedHidden: true,
	},
	shelmet: {
		inherit: true,
		unreleasedHidden: true,
	},
	accelgor: {
		inherit: true,
		unreleasedHidden: true,
	},
	stunfisk: {
		inherit: true,
		unreleasedHidden: true,
	},
	mienfoo: {
		inherit: true,
		unreleasedHidden: true,
	},
	mienshao: {
		inherit: true,
		unreleasedHidden: true,
	},
	druddigon: {
		inherit: true,
		unreleasedHidden: true,
	},
	golett: {
		inherit: true,
		unreleasedHidden: true,
	},
	golurk: {
		inherit: true,
		unreleasedHidden: true,
	},
	pawniard: {
		inherit: true,
		unreleasedHidden: true,
	},
	bisharp: {
		inherit: true,
		unreleasedHidden: true,
	},
	bouffalant: {
		inherit: true,
		unreleasedHidden: true,
	},
	braviary: {
		inherit: true,
		unreleasedHidden: true,
	},
	vullaby: {
		inherit: true,
		unreleasedHidden: true,
	},
	mandibuzz: {
		inherit: true,
		unreleasedHidden: true,
	},
	heatmor: {
		inherit: true,
		unreleasedHidden: true,
	},
	durant: {
		inherit: true,
		unreleasedHidden: true,
	},
	tornadus: {
		inherit: true,
		unreleasedHidden: true,
	},
	thundurus: {
		inherit: true,
		unreleasedHidden: true,
	},
	landorus: {
		inherit: true,
		unreleasedHidden: true,
	},
};
